import { useMutation } from '@tanstack/react-query';
import { JsonObject } from 'type-fest';

import type { MutationFunction } from '@frontend/api';
import { useRequest } from '@frontend/api';

export type UseCreateOperationData = {
  cells: {
    id: number;
    quantityId: number;
    operationId: number;
    price: number;
    manualPrice: number;
    manualUnitPrice: number;
    unitPrice: number;
  }[];
  componentId: number;
} & JsonObject;

export type UseCreateOperationRequestVars = {
  componentId: number;
  name: string;
  isFinish?: boolean;
  isOutsideService?: boolean;
  opDefId?: number;
};

export const useCreateOperation: MutationFunction<
  UseCreateOperationData,
  UseCreateOperationRequestVars
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useMutation(
    ({ componentId, ...body }) =>
      request(`/quotes/components/${componentId}/operations/`, {
        query,
        init: {
          method: 'POST',
          body,
        },
      }),
    queryOptions,
  );
};
